import type { IconNode } from '../types';

/**
 * @name tennis-racket
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuNyA0LjdjMy0zIDcuNC0zLjYgOS44LTEuMnMxLjggNi44LTEuMiA5LjhhOS41IDkuNSAwIDAgMS00LjMgMi41Yy0yLjEuNS00LjEuMS01LjUtMS4zUzcuNyAxMS4xIDguMiA5YTkuNSA5LjUgMCAwIDEgMi41LTQuMyIgLz4KICA8cGF0aCBkPSJNOC4yIDkgNiAxOGw5LTIuMiIgLz4KICA8cGF0aCBkPSJtMiAyMiA0LTQiIC8+CiAgPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/tennis-racket
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tennisRacket: IconNode = [
  [
    'path',
    {
      d: 'M10.7 4.7c3-3 7.4-3.6 9.8-1.2s1.8 6.8-1.2 9.8a9.5 9.5 0 0 1-4.3 2.5c-2.1.5-4.1.1-5.5-1.3S7.7 11.1 8.2 9a9.5 9.5 0 0 1 2.5-4.3',
      key: 'zxj3xr',
    },
  ],
  ['path', { d: 'M8.2 9 6 18l9-2.2', key: '1ivsmd' }],
  ['path', { d: 'm2 22 4-4', key: 'vwo6p4' }],
  ['circle', { cx: '20', cy: '20', r: '2', key: 'a056ao' }],
];

export default tennisRacket;
